import { render, staticRenderFns } from "./ExclusionGuard.vue?vue&type=template&id=5e21ea2e&"
import script from "./ExclusionGuard.vue?vue&type=script&lang=ts&"
export * from "./ExclusionGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports